let token = "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga";
let live = true;
// let live = false;
let api = "stage";
if (live) {
  api = "api";
}
export const API_V2_URL = `https://${api}.narendramodi.in/webapi/parikshadata?token=${token}`;
export const DETAILS_API_URL = `https://${api}.narendramodi.in/webapi/parikshadatadetail?token=${token}`;
export const TOPIC_DETAILS_API_URL = `https://${api}.narendramodi.in/webapi/parikshadatadetail?token=${token}`;
